import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardContainer, LabelValueRow, RegularText, SizedBox } from 'src/components';

export const ContactPersonCard = ({
  titleSize = 'normal',
  name,
  phone,
  email,
}: {
  titleSize?: 'small' | 'normal';
  name: string;
  phone: string;
  email?: string;
}) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      {titleSize === 'small' ? (
        <RegularText fontWeight="bold">{t('contactPerson')}</RegularText>
      ) : (
        <RegularText fontSize="large" fontWeight="bold">
          {t('contactPerson')}
        </RegularText>
      )}
      <SizedBox height="medium" />
      {!!name && <LabelValueRow fontSizeValue="large" label={t('name')} value={name} />}
      {!!email && <LabelValueRow fontSizeValue="large" label={t('email')} value={email} />}
      <LabelValueRow fontSizeValue="large" label={t('phoneNumber')} value={phone} />
    </CardContainer>
  );
};
